<div class="flex align-items-center gap-3">
    <p-dropdown
      [options]="savedSearches"
      [(ngModel)]="odabranaSpremljenaPretraga"
      optionLabel="earhiv~predlozak_pretrage~naziv"
      placeholder="Odaberite spremljenu pretragu"
      [editable]="true"
      [filter]="true" filterBy="earhiv~predlozak_pretrage~naziv" [showClear]="true"
      (onChange)="searchSelected()"
      (onClear)="handleClearListViewState()"
    ></p-dropdown>
    
    <p-button icon="pi pi-search" (onClick)="handleApplySearch()" [disabled]="!odabranaSpremljenaPretraga"></p-button>
    <p-button icon="pi pi-save" [disabled]="buttonDisabled" (onClick)="togglePanel($event)"></p-button>
    <p-button icon="pi pi-trash" [disabled]="!odabranaSpremljenaPretraga" (onClick)="deleteSearch()"></p-button>
    <p-overlayPanel #overlayPanel>
      <label>Naziv pretrage: </label><input pInputText type="text" [(ngModel)]="nazivPretrage">
      <p-button class="ml-1" icon="pi pi-check" (onClick)="handleSaveSearch()"></p-button>
    </p-overlayPanel>
</div>
